<template>
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <div v-if="this.loadingFormSubmit == false">
      <el-card style="background-color:rgba(51, 153, 255, 0.05); max-width:400px; margin: auto;">
        <h3>Invite New user</h3>
        <div>
          <el-form :model="newPropertyUserForm" ref="newPropertyUserForm" >
            <el-form-item prop="UserEmail"
            :rules="[
                { required: true, message: 'Please input email address', trigger: 'blur' },
                { type: 'email', message: 'Please input valid email address', trigger: ['blur', 'change'] }
              ]"
            >
              <el-input
                v-model="newPropertyUserForm.UserEmail"
                placeholder="Please Enter An Email Address"
                style="max-width:250px"
                @keydown.native.enter.exact.prevent="InviteUser()"
              ></el-input>
            </el-form-item>

           <el-form-item>

              <h4>Invite as</h4>

            <el-dropdown @command="selectRole" trigger="click">
              <el-button type="primary">
              {{selectedRole.rolename}}<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu   slot="dropdown">
                  <el-dropdown-item v-for="role in this.usersRoles" :command="role" :key="role.roleid">
                    {{role.rolename}}
                    <p style="  font-style: italic; font-size: 12px; float: right; margin:0;" v-if="role.customrole == false"> default </p>
                  </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

                <!-- <div>
                  <select

                    class="selector"
                    v-model="newPropertyUserForm.selectedRole"
                  >
                    <option
                      v-for="role in this.usersRoles"
                      :key="role.roleid"
                      >{{ role.rolename }}</option >
                  </select>
                </div> -->

           </el-form-item>


          </el-form>
          <el-button @click.native="InviteUser()">Invite User</el-button>
          <el-button @click.native="closeAddUserToPropertyForm()">Cancel</el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
export default {
  props: {
    property: Object
  },
  data() {
    return {
    usersRoles: [],
    selectedRole: {},
      newPropertyUserForm: {
        UserEmail: "",
        selectedRoleId:""
      },
       invalid: false,
       loadingFormSubmit: false
    };
  },
  created(){
   EventService.getAllRoles(this.$route.params.propertyid).then( response => {
    this.usersRoles = response.data.roles;
    this.selectedRole = this.usersRoles.filter(x => x.rolename == "worker (system role)")[0]
          this.newPropertyUserForm.selectedRoleId = this.selectedRole.roleid;
   })
  },
  methods: {
        selectRole(role){
     this.selectedRole = role;
      // this.roleSelected = true;
      this.newPropertyUserForm.selectedRoleId = role.roleid;
    },
    InviteUser() {

        this.$refs["newPropertyUserForm"].validate((valid) => {
          if (valid == true) {

            } else {
            this.invalid = true;
            return false;
          }
        });
       
       if(this.invalid == true){
         this.invalid = false;
        return;
       }
       
      this.loadingFormSubmit = true;

      EventService.InviteUserToProperty(
        { propertyid: [this.property.propertyid] },
        this.newPropertyUserForm.UserEmail,
        this.newPropertyUserForm.selectedRoleId
      ).then(response => {

          this.$store.dispatch("addNotification", {
            type: "success",
            Message: "Contact Invited"
          });

        if(response.data.firstname == null){
         response.data.firstname = "Not signed up yet";
      }       
          this.$emit("newuseronproperty", response.data);
          this.closeAddUserToPropertyForm();
      })
       .catch(error => {

          this.closeAddUserToPropertyForm();
          console.log(error);
        });

      this.newPropertyUserEmail = "";
    },
    closeAddUserToPropertyForm() {
      this.$emit("closeaddusertopropertyform");
    }
  }
};
</script>

<style scoped>
h4{
   margin: 0px;
}
</style>
